export default "__VITE_ASSET__b6b757dd__"